import { render, staticRenderFns } from "./RoutingSetting.vue?vue&type=template&id=ae132692&scoped=true"
import script from "./RoutingSetting.vue?vue&type=script&lang=ts"
export * from "./RoutingSetting.vue?vue&type=script&lang=ts"
import style0 from "./RoutingSetting.vue?vue&type=style&index=0&id=ae132692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae132692",
  null
  
)

export default component.exports